import serviceBase from 'app/Services/serviceBase'
import { useEffect, useRef } from 'react'

const getMarketingSectionById = (id) => {
  let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/marketing-custom-sections-by-id/${id}`
  return serviceBase.get(url).then((response) => {
    return response.data
  })
}
const getMarketingSectionByName = (name) => {
  let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/marketing-custom-sections-by-name/${name}`
  return serviceBase.get(url).then((response) => {
    return response
  })
}
const saveMarketingSection = (
  formData,
  iarMember,
  setLocalState,
  onClose,
  errorSnackBarActions,
  setMarketingSections,
  isCreate,
  isCreateFromDialog,
  departmentMenuMarketingSection,
  setMenuMarketingSections,
  id
) => {
  let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section`

  serviceBase.get(`${url}/emit-start?id=${id}`)
  serviceBase
    .post(url, formData, {
      fullusername: iarMember.fullName
    })
    .then(
      (response) => {
        console.log('POST Marketing Section: ', response)
        setLocalState((prevState) => ({
          ...prevState,
          posting: false
        }))
        onClose()
        if (isCreate && isCreateFromDialog) {
          console.log('The MCS was created')
        } else console.log('The MCS was updated')

        if (response.data._id === departmentMenuMarketingSection?.id) {
          departmentMenuMarketingSection.title = response.title
          setMenuMarketingSections([{ id: response.data._id, title: response.data.title }])
        }
      },
      (err) => {
        console.log(err)
        setLocalState((prevState) => ({
          ...prevState,
          posting: false
        }))
        errorSnackBarActions.setOpen(true)
        onClose()
      }
    )
}

const saveMarketingSectionPreview = (
  formData,
  iarMember,
  setLocalState,
  onClose,
  errorSnackBarActions,
  isCreate,
  isCreateFromDialog,
  departmentMenuMarketingSection,
  setMenuMarketingSections,
  id
) => {
  let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview`
  const urlEmitMessage = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section`

  serviceBase.get(`${urlEmitMessage}/emit-start?id=${id}`)
  serviceBase
    .post(url, formData, {
      fullusername: iarMember.fullName
    })
    .then(
      (response) => {
        console.log('POST Marketing Section: ', response)
        setLocalState((prevState) => ({
          ...prevState,
          posting: false
        }))
        onClose()
        if (isCreate && isCreateFromDialog) {
          console.log('The MCS was created')
        } else console.log('The MCS was updated')

        if (response.data._id === departmentMenuMarketingSection?.id) {
          departmentMenuMarketingSection.title = response.title
        }
      },
      (err) => {
        console.log(err)
        setLocalState((prevState) => ({
          ...prevState,
          posting: false
        }))
        errorSnackBarActions.setOpen(true)
        onClose()
      }
    )
}
const handleChange = (evt, marketingSetter) => {
  const value = evt.target.value
  marketingSetter((prevState) => ({ ...prevState, [evt.target.name]: value }))
}

const removeOnlineVideo = (file, array, setter) => {
  const tempOnlineVideos = array.filter((i) => i.originalName !== file.originalName)
  setter((prevState) => ({
    ...prevState,
    onlineVideos: tempOnlineVideos
  }))
}
const removeAsset = (file, type, images, videos, marketingSetter, setLocalState) => {
  switch (type) {
    case 'image':
      const tempImages = images.filter((i) => i.fileName !== file.fileName)
      marketingSetter((prevState) => ({
        ...prevState,
        images: tempImages
      }))

      setLocalState((prevState) => ({
        ...prevState,
        deletedFiles: [...prevState.deletedFiles, file.fileName]
      }))
      break
    case 'video':
      const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
      marketingSetter((prevState) => ({
        ...prevState,
        videos: tempVideos
      }))
      setLocalState((prevState) => ({
        ...prevState,
        deletedFiles: [...prevState.deletedFiles, file.fileName]
      }))
      break
    default:
      break
  }
}
const INITIAL_STATE = {
  _id: '',
  images: [],
  videos: [],
  onlineVideos: [],
  isDiscarded: false,
  title: '',
  positionFiles: 0,
  bodyText: ''
}
function useEffectAfterMount(effect, deps) {
  const isFirstRun = useRef(true)

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      return
    }

    if (effect) effect()
  }, deps)
}
function getVideosPayload(videos, previousVideos) {
  let videosPayload = []
  if (videos.length) {
    videosPayload = videos
      .filter((video) => !previousVideos.some((x) => x.fileName === video.fileName))
      .map((x) => ({
        originalName: x.FileName,
        type: x.type,
        fileSize: x.fileSize,
        caption: x.caption,
        secondsDuration: x.secondsDuration,
        binary: x.binary
      }))
  }
  return videosPayload
}

function getImagesPayload(images, previousImages) {
  let imagesPayload = []

  images.forEach((image) => {
    if (image.file === undefined) return

    let fileExists = !previousImages.some((i) => {
      return i.fileName === image.fileName
    })

    if (fileExists) {
      imagesPayload.push({
        file: image.file,
        originalName: image.originalName,
        caption: image.caption,
        fileSize: image.fileSize,
        type: image.type
      })
    }
  })

  return { imagesPayload }
}

function getOnlineVideosPayload(onlineVideos, previousOnlineVideos) {
  const onlineVideosPayload = []
  onlineVideos.forEach((elem) => {
    onlineVideosPayload.push({
      originalName: elem.originalName,
      caption: elem.caption,
      type: elem.type,
      provider: elem.provider,
      url: elem.url,
      fileSize: elem.fileSize,
      binary: elem.binary
    })
  })

  return { onlineVideosPayload }
}

function getClonedImagesPayload(images, previousImages) {
  const clonedImgs = images.filter((i) =>
    previousImages.some((previousImg) => previousImg.fileName === i.fileName)
  )
  const clonedImgPayload = []

  clonedImgs.forEach((img) =>
    clonedImgPayload.push({
      fileName: img.fileName,
      originalName: img.originalName,
      caption: img.caption,
      fileSize: img.fileSize,
      type: img.type,
      url: img.url
    })
  )
  return clonedImgPayload
}
function getClonedVideosPayload(videos, previousVideos) {
  const clonedVids = videos.filter((v) =>
    previousVideos.some((previousVid) => previousVid.fileName === v.fileName)
  )
  const clonedVidsPayload = []

  clonedVids.forEach((video) =>
    clonedVidsPayload.push({
      fileName: video.fileName,
      originalName: video.originalName,
      caption: video.caption,
      fileSize: video.fileSize,
      type: video.type,
      url: video.url,
      secondsDuration: video.secondsDuration
    })
  )
  return clonedVidsPayload
}

const processAndGetImages = (images, discardImages) => {
  let imagesPayload = []

  if (images) {
    images.forEach((image) => {
      let fileExists = !discardImages.some((img) => img.fileName === image.fileName)

      if (fileExists) {
        imagesPayload.push({
          file: image.file,
          originalName: image.originalName,
          caption: image.caption,
          fileSize: image.fileSize,
          type: image.type
        })
      }
    })
  } else {
    imagesPayload = images
  }
  return imagesPayload
}

const publish = async (id) => {
  try {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/${id}/publish`

    const response = await serviceBase.post(url)

    if (response?.status !== 200) throw new Error(response.data)

    return response.data
  } catch (err) {
    console.error(err)
    throw new Error('Error attempting to publish Marketing custom sections')
  }
}

const getMarketingSectionPreviewById = (id) => {
  let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/${id}`
  return serviceBase.get(url).then((response) => {
    return response.data
  })
}

const getMarketingSectionPreviewByName = (name) => {
  let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/marketing-custom-sections-by-name/${name}`
  return serviceBase.get(url).then((response) => {
    return response
  })
}

export {
  handleChange,
  processAndGetImages,
  removeOnlineVideo,
  removeAsset,
  getMarketingSectionById,
  useEffectAfterMount,
  INITIAL_STATE,
  getVideosPayload,
  getImagesPayload,
  getOnlineVideosPayload,
  getClonedImagesPayload,
  getClonedVideosPayload,
  saveMarketingSection,
  saveMarketingSectionPreview,
  getMarketingSectionPreviewById,
  getMarketingSectionPreviewByName,
  getMarketingSectionByName,
  publish
}
